import { render, staticRenderFns } from "./HelpCenterList.vue?vue&type=template&id=1b5d6c9c&scoped=true&"
import script from "./HelpCenterList.vue?vue&type=script&lang=js&"
export * from "./HelpCenterList.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterList.vue?vue&type=style&index=0&id=1b5d6c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d6c9c",
  null
  
)

export default component.exports